<template>
  <div ref="description" class="ellipsis-content" :class="ellipsisContentVisible ? 'ellipsis' : ''">
    <div>
      {{ keyword }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'EllipsisCard',

  props: {
    keyword: {
      type: String
    }
  },

  data() {
    return {
      ellipsisContentVisible: false
    };
  },

  mounted() {
    this.onCalcEllipsisStyles();
  },

  methods: {
    /**
     * 计算是否需要加省略号
     */
    onCalcEllipsisStyles() {
      const outerHeight = this.$refs.description.offsetHeight;
      const innerHeight = this.$refs.description.querySelector('div').offsetHeight;
      if (outerHeight < innerHeight) {
        this.ellipsisContentVisible = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ellipsis-content {
  display: flex;
  align-items: center;
  height: 4em;
  line-height: 2em;
  flex-wrap: wrap;
  overflow: hidden;

  &.ellipsis {
    position: relative;

    &::after {
      content: '...';
      position: absolute;
      bottom: 0;
      right: 0;
      padding-left: 6px;
      background-color: #fff;
    }
  }
}
</style>
